import { AdaptiveSizes } from "./constants";
import { PARAM_EMPTY_VALUE } from "../constants";
export var sizeToPixel = function sizeToPixel(size) {
  if (!size) return 0;
  if (size in AdaptiveSizes) return AdaptiveSizes[size];
  return parseInt(size.toString(), 10);
};
export var sizeToPixelSort = function sizeToPixelSort(a, b) {
  return sizeToPixel(b) - sizeToPixel(a);
};
export var getClosestOfKeys = function getClosestOfKeys(keys, key) {
  var pixelsOfKey = sizeToPixel(key);
  for (var i = keys.length - 1; i >= 0; i -= 1) {
    if (sizeToPixel(keys[i]) >= pixelsOfKey) return keys[i];
  }
  return PARAM_EMPTY_VALUE;
};
/**
 * used to check if two intervals overlap
 */
export function createInterval() {
  var maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PARAM_EMPTY_VALUE;
  var minSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var maxSizeInPixel = sizeToPixel(maxSize);
  var minSizeInPixel = sizeToPixel(minSize);
  return {
    overlapsWith: function overlapsWith() {
      var currentMaxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PARAM_EMPTY_VALUE;
      var currentMinSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return minSizeInPixel < sizeToPixel(currentMaxSize) && sizeToPixel(currentMinSize) < maxSizeInPixel;
    }
  };
}
export function convertKeysToIntervals(sortedKeys) {
  return sortedKeys.map(function (maxSize, index) {
    return [maxSize, sortedKeys[index + 1]];
  });
}